import React from 'react';

import { CustomFieldsIcon } from '@/shared/assets/icons/custom-fields-icon';
import { DeploymentIcon } from '@/shared/assets/icons/deployment-icon';
import { DevicesIcon } from '@/shared/assets/icons/devices-icon';
import { DocumentsIcon } from '@/shared/assets/icons/documents-icon';
import { FolderIcon } from '@/shared/assets/icons/folder-icon';
import { GatewayIcon } from '@/shared/assets/icons/gateway-icon';
import { IdeaasIcon } from '@/shared/assets/icons/ideaas-icon';
import { LicenseIcon } from '@/shared/assets/icons/license-icon';
import { LockIcon } from '@/shared/assets/icons/lock-icon';
import { LogsIcon } from '@/shared/assets/icons/logs-icon';
import { ManageCompanyIcon } from '@/shared/assets/icons/manage-company-icon';
import { NotificationIcon } from '@/shared/assets/icons/notification-icon';
import { PipelinesIcon } from '@/shared/assets/icons/pipelines-icon';
import { ProjectsIcon } from '@/shared/assets/icons/projects-icon';
import { SettingsIcon } from '@/shared/assets/icons/settings-icon';
import { TagIcon } from '@/shared/assets/icons/tag-icon';
import { TenantIcon } from '@/shared/assets/icons/tenant-icon';
import { UserIcon } from '@/shared/assets/icons/user-icon';
import { UserRoleIcon } from '@/shared/assets/icons/user-role-icon';
import { VaultIcon } from '@/shared/assets/icons/vault-icon';
import { VulnerabilitiesIcon } from '@/shared/assets/icons/vulnerabilities-icon';
import { WebhookIcon } from '@/shared/assets/icons/webhook-icon';
import { WorkstationIcon } from '@/shared/assets/icons/workstation-icon';
import {
  ResourceTypeEnum,
  TResourceIconProps,
} from '@/shared/components/ui/resource-icon/resource-icon.types';

export const ResourceIcon: React.FC<TResourceIconProps> = ({
  resourceType,
  iconProps,
}) => {
  switch (resourceType) {
    case ResourceTypeEnum.Ideaas:
      return <IdeaasIcon {...iconProps} />;
    case ResourceTypeEnum.Document:
      return <DocumentsIcon {...iconProps} />;
    case ResourceTypeEnum.Device:
      return <DevicesIcon {...iconProps} />;
    case ResourceTypeEnum.Gateway:
      return <GatewayIcon {...iconProps} />;
    case ResourceTypeEnum.Workstation:
      return <WorkstationIcon {...iconProps} />;
    case ResourceTypeEnum.Project:
      return <ProjectsIcon {...iconProps} />;
    case ResourceTypeEnum.Identity:
    case ResourceTypeEnum.BackofficeUser:
      return <UserIcon {...iconProps} />;
    case ResourceTypeEnum.Integration:
      return <SettingsIcon {...iconProps} />;
    case ResourceTypeEnum.Vault:
      return <VaultIcon {...iconProps} />;
    case ResourceTypeEnum.Secret:
      return <LockIcon {...iconProps} />;
    case ResourceTypeEnum.Pipeline:
      return <PipelinesIcon {...iconProps} />;
    case ResourceTypeEnum.Webhook:
      return <WebhookIcon {...iconProps} />;
    case ResourceTypeEnum.License:
      return <LicenseIcon {...iconProps} />;
    case ResourceTypeEnum.Offboarding:
      return <ManageCompanyIcon {...iconProps} />;
    case ResourceTypeEnum.Tag:
      return <TagIcon {...iconProps} />;
    case ResourceTypeEnum.AuditLog:
      return <LogsIcon {...iconProps} />;
    case ResourceTypeEnum.Vulnerabilities:
      return <VulnerabilitiesIcon {...iconProps} />;
    case ResourceTypeEnum.CustomField:
      return <CustomFieldsIcon {...iconProps} />;
    case ResourceTypeEnum.Notification:
      return <NotificationIcon {...iconProps} />;
    case ResourceTypeEnum.DeploymentRequest:
      return <DeploymentIcon {...iconProps} />;
    case ResourceTypeEnum.BackofficeUserRole:
      return <UserRoleIcon {...iconProps} />;
    case ResourceTypeEnum.BackofficeTenant:
      return <TenantIcon {...iconProps} />;
    case ResourceTypeEnum.BackofficeGroup:
    default:
      return <FolderIcon {...iconProps} />;
  }
};
